import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "store/store";

export const selectSiteSpecificCodes = createSelector(
  [(state: RootState) => state.siteSpecificCodes],
  (siteSpecificCodes) => {
    const nosCodes = [
      ...new Set(siteSpecificCodes?.codes?.map((c) => c.nos_code) || []),
    ];

    const nosToSiteSpecificCodes = siteSpecificCodes?.codes?.reduce(
      (groupedCodes, currentCode) => {
        if (
          !currentCode.nos_code ||
          !currentCode.site ||
          !currentCode.site_specific_code
        )
          return groupedCodes;

        return {
          ...groupedCodes,
          [currentCode.nos_code]: {
            ...groupedCodes[currentCode.nos_code],
            [currentCode.site]: currentCode.site_specific_code,
          },
        };
      },
      {} as { [key: string]: { [key: string]: string } }
    );

    const termsToSite = siteSpecificCodes?.sites
      ? Object.fromEntries(
          siteSpecificCodes?.sites
            ?.map(({ site, terms }) => terms.map((term) => [term, site]))
            .flat()
        )
      : {};

    return { nosCodes, nosToSiteSpecificCodes, termsToSite };
  }
);
